import { useCallback } from 'react';
import { apiGet } from '../../lib/api';
import { SearchCombo } from './SearchCombo';

const inr = (v) => `₹${Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

/** GRN fix #3 — type-to-search receivable PO combo (server search, paged 20).
 *  `offlineRows`: slim cached rows used (client-side filter) when offline. */
export function POSearchSelect({ value, onSelect, projectId, offlineRows = null, offline = false, testid = 'grn-po-select', disabled = false }) {
  const fetchPage = useCallback(async (q, page) => {
    if (offline && Array.isArray(offlineRows)) {
      const t = (q || '').toLowerCase();
      const rows = offlineRows.filter(r => !t || `${r.po_no} ${r.vendor_name} ${r.project_name}`.toLowerCase().includes(t));
      return { items: rows.slice(0, page * 20), total: rows.length };
    }
    return apiGet('/stores/pos/search', { q: q || undefined, project_id: projectId || undefined, page, limit: 20 });
  }, [offline, offlineRows, projectId]);

  return (
    <SearchCombo
      value={value} displayLabel={value ? `${value.po_no} · ${value.vendor_name || ''}${value.project_name ? ` · ${value.project_name}` : ''}` : ''}
      onSelect={onSelect} fetchPage={fetchPage} getKey={(r) => r.id} testid={testid} disabled={disabled}
      placeholder="Search PO number, vendor or project…"
      emptyText={(q) => (q ? `No receivable PO matches '${q}'` : 'No approved POs available to receive against')}
      note={offline ? 'Offline — showing recently cached POs only' : null}
      renderRow={(r) => (
        <div className="flex items-center justify-between gap-2">
          <div className="min-w-0">
            <div className="font-mono font-semibold">{r.po_no} <span className="font-sans font-normal text-slate-600">· {r.vendor_name}</span></div>
            <div className="text-[11px] text-slate-500 truncate">{r.project_name || '—'} · {inr(r.total_value)} · {r.pending_line_count ?? r.line_count} line{(r.pending_line_count ?? r.line_count) === 1 ? '' : 's'} pending</div>
          </div>
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 shrink-0">{r.status}</span>
        </div>
      )}
    />
  );
}
